// src/components/layout/Footer.js

import React from 'react';

function Footer() {
  return (
    <footer>
      <p>&copy; {new Date().getFullYear()} Max Hovding. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
